import { Typography } from "@mui/material";
import React from "react";

const ProgressBarTempo = ({ isYear, Percentage = 0, text }) => {
  const count = isYear
    ? (Percentage?.year || 0) * 10 + (Percentage?.month || 0) // Handle potential undefined values
    : Percentage;

  const content = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        // background : 'lightblue',
        maxWidth : '160px'
        
      }}
    >
      <div style={myProgressStyle}>
        <div style={myBarStyle(count)}>
          {count >= 5 && (
            <div style={textStyle}>
              {isYear
                ? `${Percentage?.year}y ${Percentage?.month}m`
                : `${count}%`}
            </div>
          )}
        </div>
        {count < 5 && (
          <div style={lowTextStyle}>
            {isYear
              ? `${Percentage?.year}y ${Percentage?.month}m`
              : `${count}%`}
          </div>
        )}

        {isYear && (
          <>
            <div style={labelStyle}>0</div>
            <div style={rightLabelStyle}>10 years</div>
          </>
        )}
      </div>
      <div style={{ width: "80%", margin: "5px" }}>
        <Typography style={{ textAlign: "center" }}>{text}</Typography>
      </div>
    </div>
  );

  return content;
};

export default ProgressBarTempo;

const myProgressStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  alignItems: "center",
  gap: "3px",
  marginTop: "8px",
  position: "relative",
  height: "250px", // Adjust the height to the desired size
  width: "80px",
  backgroundColor: "#eeeeee",
};

const myBarStyle = (count) => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: `${Math.min(count, 100)}%`,
    transition: "height 2s",
    backgroundColor: "#dc002d",
    color: "white",
    position: "relative",
  };
};

const textStyle = {
  position: "absolute",
  bottom: "5px", // Position the text at the bottom of the red part
  fontSize: "16px",
  color: "white",
};

const lowTextStyle = {
  position: "absolute",
  top: "5px", // Position the text at the top when the bar is very low
  fontSize: "14px",
  color: "#555",
};

const labelStyle = {
  position: "absolute",
  bottom: "-22px",
  width: "100%",
  textAlign: "center",
  padding: "5px",
  fontSize: "14px",
  color: "#555",
};

const rightLabelStyle = {
  position: "absolute",
  top: "-22px",
  width: "100%",
  textAlign: "center",
  padding: "5px",
  fontSize: "14px",
  color: "#555",
};
